module.exports = __webpack_public_path__ + "a50d129fb2363169be1fd9a1c525f9fa.png";